import { connect } from 'react-redux';
import DataJadwalMatpelDetails from '../../views/Settings/DataJadwalMatpelDetails.view';
import { getClasses, getParamOptionsAcademics, getPrmLevels, getPeriodsOptions } from '../../states/thunks/options.thunk';
import { listScheduleSubject, deleteScheduleSubject, listReportSchedule, getListScheduleSubject, listReportDetailsSchedule } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleListScheduleSubject: (payload, goback) => dispatch(listScheduleSubject(payload, goback)),
    handleListReportSchedule: (payload, goback) => dispatch(listReportSchedule(payload, goback)),
    handleListReportDetailsSchedule: (payload, goback) => dispatch(listReportDetailsSchedule(payload, goback)),
    handleDeleteScheduleSubject: (payload, goback) => dispatch(deleteScheduleSubject(payload, goback)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    handleGetScheduleSubject: payload => dispatch(getListScheduleSubject(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DataJadwalMatpelDetails);
